import {
  DonorType,
  GroundConfirmation,
  LogisticsProviderType,
  OrganType,
  QuoteStatus,
  RoutePlanStatus,
} from '@/api/apis/case';
import { randomizationFilterTypeNames } from '@/constants/case/case.constants';
import { getNameValuesFromEnumNames } from '@/utils/helpers';

export const organsItems = Object.values(OrganType).map((i) => ({ value: i, name: i }));
export const donorTypesItems = Object.values(DonorType).map((i) => ({ value: i, name: i }));
export const groundConfirmationItems = Object.values(GroundConfirmation).map((i) => ({ value: i, name: i }));
export const logisticsStatusItems = [
  { value: RoutePlanStatus.RoutePlanningStart, name: 'Route Planning' },
  { value: RoutePlanStatus.WaitingForAviationApproval, name: 'Waiting For Aviation Approval' },
  { value: RoutePlanStatus.WaitingForQuoteApproval, name: 'Quote Sent for Top 3 Approval' },
  { value: RoutePlanStatus.RoutePlanningDone, name: 'Route Planning Done' },
  { value: RoutePlanStatus.PendingResourcesBooking, name: 'Acknowledgement Pending' },
  { value: RoutePlanStatus.ResourcesBooked, name: 'Resources Assigned' },
];
export const caseQuoteStatusItems = [
  { value: QuoteStatus.NoQuote, name: 'No Quote' },
  { value: QuoteStatus.Created, name: 'Quote Created' },
  { value: QuoteStatus.ApprovedInternally, name: 'Quote Approved Internally' },
  { value: QuoteStatus.SentToTXCenter, name: 'Quote Sent To TX Center' },
  { value: QuoteStatus.Approved, name: 'Quote Approved' },
  { value: QuoteStatus.Rejected, name: 'Quote Rejected' },
  { value: QuoteStatus.Recalled, name: 'Quote Recalled' },
];
export const providersItems = [
  { value: LogisticsProviderType.TMDX, name: 'TMDX' },
  { value: LogisticsProviderType.SupplementalLiftProvider, name: 'Supplemental Lift Provider' },
  { value: LogisticsProviderType.TMDXAffiliate, name: 'TMDX Affiliate' },
  { value: LogisticsProviderType.TXCenterProvider, name: 'TX Center Provider' },
  { value: LogisticsProviderType.SelfServiced, name: 'Self-Serviced' },
  { value: LogisticsProviderType.TEDS, name: 'TEDS' },
];

export const randomizationFilterTypeItems = getNameValuesFromEnumNames(randomizationFilterTypeNames);
